module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    class: {
      'dark': _vm.dark, 'active': _vm.isOpen
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [(!_vm.dark) ? _c('img', {
    attrs: {
      "src": require("../../assets/logo.png")
    }
  }) : _c('img', {
    attrs: {
      "src": require("../../assets/logogr.png")
    }
  })]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.isOpen),
      expression: "isOpen"
    }],
    staticClass: "nav-toggle",
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.isOpen) ? _vm._i(_vm.isOpen, null) > -1 : (_vm.isOpen)
    },
    on: {
      "change": _vm.preventScroll,
      "__c": function($event) {
        var $$a = _vm.isOpen,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.isOpen = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.isOpen = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.isOpen = $$c
        }
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "hamburger"
  }, _vm._l((3), function(i) {
    return _c('span', {
      staticClass: "hamburger-item"
    })
  })), _vm._v(" "), _c('nav', [_vm._l((_vm.navigation), function(item, index) {
    return [_c('router-link', {
      key: item.text,
      attrs: {
        "to": item.link
      }
    }, [_vm._v("\n        " + _vm._s(item.text) + "\n      ")]), _vm._v(" "), (index != _vm.navigation.length - 1) ? _c('span', [_vm._v("/")]) : _vm._e()]
  })], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0ec2be5c","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/js/components/navigation.vue
// module id = 150
// module chunks = 0